/** @format */

import {
	AppProductReviewState,
	InvalidResponse,
	Review,
	selectProductIncludedInformation,
	selectProductReviews
} from '@product-reviews/data-access';
import { Store, select } from '@ngrx/store';
import { filter, map, shareReplay } from 'rxjs/operators';

import { Component } from '@angular/core';

@Component({
	selector: 'product-reviews-review-latest-carousel',
	templateUrl: './review-latest-carousel.component.html',
	styleUrl: './review-latest-carousel.component.scss',
	standalone: false
})
export class ReviewLatestCarrouselComponent {
	latestReview$ = this.store.pipe(
		select(selectProductReviews),
		filter((review) => review.length > 0),
		map((reviews: Review[]) => reviews.slice(0, 5)),
		shareReplay(1)
	);

	productInformation$ = this.store.pipe(
		select(selectProductIncludedInformation),
		filter((product) => !(product instanceof InvalidResponse)),
		shareReplay(1)
	);

	constructor(private store: Store<AppProductReviewState>) {}

	/*
	 * Track review changed
	 */
	protected trackByReview(index: number, review: Review): string {
		return review.Id;
	}
}
